











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export enum SpotlightTextBorderType {
    Rounded = 'spotlight-text--rounded-border',
    Squared = 'spotlight-text--squared-border',
}

export enum SpotlightTextColor {
    Primary = 'spotlight-text--primary',
    White = 'spotlight-text--white',
    Error = 'spotlight-text--error',
    Secondary = 'spotlight-text--secondary',
    Transparent = 'spotlight-text--transparent',
}

@Component
export default class SpotlightText extends Vue {
    @Prop({ default: 'undefined text prop' }) private text!: string;
    @Prop({ default: SpotlightTextBorderType.Rounded }) private borderType!: SpotlightTextBorderType;
    @Prop({ default: SpotlightTextColor.White }) private color!: SpotlightTextColor;

    get hasSlot() {
      return !!this.$slots.default;
    }

}
